var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "gwnl-eval-publish-msg__title standard-size-16 color-gray-10 font-weight-500",
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("pc_gwnl_eval_notifiAssessArrange")) +
              "\n  "
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "mt16 ml15" },
        [
          _c(
            "yxt-checkbox",
            {
              attrs: { "true-label": 1, "false-label": 0 },
              on: { change: _vm.changeNotify },
              model: {
                value: _vm.enabledNotify,
                callback: function ($$v) {
                  _vm.enabledNotify = $$v
                },
                expression: "enabledNotify",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_gwnl_eval_sendNotifiArrange")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm.enabledNotify === 1
        ? _c(
            "div",
            { staticClass: "ml40" },
            [
              _c(
                "yxt-radio",
                {
                  staticClass: "mt24 mb24",
                  attrs: { label: 0 },
                  model: {
                    value: _vm.customization,
                    callback: function ($$v) {
                      _vm.customization = $$v
                    },
                    expression: "customization",
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("pc_gwnl_eval_useDefaultTemplate")) +
                      "\n    "
                  ),
                ]
              ),
              _c("br"),
              _c(
                "yxt-radio",
                {
                  attrs: { label: 1 },
                  model: {
                    value: _vm.customization,
                    callback: function ($$v) {
                      _vm.customization = $$v
                    },
                    expression: "customization",
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("pc_gwnl_eval_usePersonalizedTemplates")) +
                      "\n    "
                  ),
                ]
              ),
              _vm.customization === 1
                ? _c("span", { staticClass: "yxt-radio__input" }, [
                    _c(
                      "span",
                      {
                        staticClass: "color-primary-6 mr16 hand",
                        on: {
                          click: function ($event) {
                            return _vm.showTemplate(_vm.tCode)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("pc_gwnl_eval_eval_notify")) +
                            "\n      "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.enabledNotify === 1 && !_vm.noTiming
        ? _c(
            "div",
            { staticClass: "gwnl-eval-publish-timing mt32 pb24" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "gwnl-eval-publish-msg__title standard-size-16 color-gray-10 font-weight-500",
                },
                [
                  _c(
                    "div",
                    { staticClass: "align-items-center" },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("pc_gwnl_eval_timedMsgSettings"))),
                      ]),
                      _c(
                        "yxt-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            placement: "top",
                            content: _vm
                              .$t("pc_talent_tips_eval_send_notice")
                              .d("定时发送评估安排通知"),
                          },
                        },
                        [
                          _c("yxt-svg", {
                            staticClass: "ml4 color-gray-6 v-mid",
                            attrs: {
                              width: "16px",
                              height: "16px",
                              "icon-class": "question-cirlce-o",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "mt16 ml15" },
                [
                  _c(
                    "yxt-checkbox",
                    {
                      attrs: { "true-label": 1, "false-label": 0 },
                      on: { change: _vm.changeScheduled },
                      model: {
                        value: _vm.scheduled,
                        callback: function ($$v) {
                          _vm.scheduled = $$v
                        },
                        expression: "scheduled",
                      },
                    },
                    [
                      _c("span", { staticClass: "color-gray-9" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("pc_gwnl_eval_timedMsgSettings"))
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm.scheduled === 1
                ? _c(
                    "yxt-form",
                    {
                      ref: "dynamicValidateForm",
                      staticClass: "ml40 mt24",
                      attrs: {
                        model: _vm.dynamicValidateForm,
                        "label-width": "0px",
                      },
                    },
                    _vm._l(_vm.scheduleList, function (item, index) {
                      return _c(
                        "yxt-form-item",
                        {
                          key: index,
                          staticClass: "gwnl-eval-publish__schedule",
                          attrs: {
                            prop: "scheduleList." + index + ".notifyTime",
                            rules: _vm.timeRules,
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              ref: "pbText",
                              refInFor: true,
                              staticClass: "mr12 d-in-block",
                            },
                            [_vm._v(_vm._s(_vm.$t("pc_gwnl_eval_willBe")))]
                          ),
                          _c("yxt-date-picker", {
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t(
                                "pc_gwnl_eval_selectDateAndTime"
                              ),
                              "picker-options": _vm.pickerOptions,
                            },
                            model: {
                              value: item.notifyTime,
                              callback: function ($$v) {
                                _vm.$set(item, "notifyTime", $$v)
                              },
                              expression: "item.notifyTime",
                            },
                          }),
                          _c("span", { staticClass: "ml12" }, [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .$t("pc_talent_msg_eval_send_notify")
                                  .d("发送评估安排通知")
                              )
                            ),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm.scheduled === 1
                ? _c(
                    "div",
                    { staticClass: "mt24 ml40 yxtbiz-flex-center" },
                    [
                      _c("span", { staticClass: "vertical-align--middle" }, [
                        _vm._v(
                          _vm._s(_vm.$t("pc_gwnl_eval_messageSendingChannel"))
                        ),
                      ]),
                      _vm._l(_vm.msgList, function (icon) {
                        return _c("yxt-svg", {
                          key: icon,
                          staticClass: "ml12 vertical-align--middle",
                          attrs: {
                            "remote-url":
                              _vm.$staticBaseUrl +
                              "ufd/b0174a/evaluation/pc/svg/eval",
                            width: "24px",
                            height: "24px",
                            "icon-class": icon,
                          },
                        })
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("yxtbiz-i18n-custom-template", {
        attrs: {
          code: _vm.tCode,
          "target-id": _vm.id,
          visible: _vm.visible[_vm.tCode],
        },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.visible, _vm.tCode, $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }